import React from 'react';
import { IconProps } from './model/IconInterface';

const FaxIcon: React.FC<IconProps> = ({ size = 20, color = 'currentColor', fill }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={fill ? color : 'none'}
      stroke={color}
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
    >
      <rect x="2" y="6" width="4" height="14" rx="1.5" />
      <path d="M10 10V3h7l3 3v4" />
      <rect x="8" y="10" width="14" height="10" rx="2" />
      <path d="M12 15h.01" />
      <path d="M15 15h.01" />
      <path d="M18 15h.01" />
    </svg>
  );
};

export default FaxIcon;
